import React from "react";
import { SearchIcon } from "./icons";
import { useTranslation } from "react-i18next";

const mockLibraryResources = [
  { id: 1, title: "Introduction to Modern Physics", type: "Book", author: "Dr. Alan Rhoades", cover: "https://placehold.co/400x600/3b82f6/ffffff?text=Physics" },
  { id: 2, title: "The World of Photosynthesis", type: "Video", duration: "15 min", cover: "https://placehold.co/400x600/10b981/ffffff?text=Biology" },
  { id: 3, title: "Shakespeare's Sonnets Analysis", type: "Article", author: "Prof. Eleanor Vance", cover: "https://placehold.co/400x600/8b5cf6/ffffff?text=Literature" },
  { id: 4, title: "Calculus Interactive Simulation", type: "Simulation", subject: "Mathematics", cover: "https://placehold.co/400x600/f97316/ffffff?text=Math" },
];

const LibraryResource = () => {
  const { t } = useTranslation();

  return (
    <div className="p-6 sm:p-8 lg:p-10 bg-gray-50 min-h-screen space-y-8">
      {/* --- Header Section --- */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">{t("library.title")}</h2>
        <div className="flex items-center space-x-4">
          {/* --- Search Input --- */}
          <div className="relative">
            <input
              type="text"
              placeholder={t("library.searchPlaceholder")}
              className="pl-10 pr-4 py-2 border rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
            />
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
          </div>

          {/* --- Add Button --- */}
          <button className="bg-indigo-600 text-white font-semibold py-2 px-4 rounded-md hover:bg-indigo-700 transition">
            {t("library.addResource")}
          </button>
        </div>
      </div>

      {/* --- Resource Grid --- */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {mockLibraryResources.map((resource) => (
          <div
            key={resource.id}
            className="bg-white rounded-2xl shadow-sm overflow-hidden group"
          >
            <img
              src={resource.cover}
              alt={resource.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <span className="text-xs bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full">
                {t(`library.type.${resource.type.toLowerCase()}`)}
              </span>
              <h3 className="font-bold mt-2 text-gray-800">{resource.title}</h3>
              <p className="text-sm text-gray-500">
                {resource.author || resource.duration || resource.subject}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LibraryResource;
